
import { toast } from '@/hooks/use-toast';

export const useCartHandlers = (
  appliedCredit: number,
  applyCreditStorage: (amount: number) => void,
  resetAppliedCredit: () => void,
  setPromoCodeStorage: (code: string) => void,
  calculateCartTotal: () => number,
  calculateShippingCost: () => number,
  discount: number,
  setDiscount: (discount: number) => void,
  setPromoEligibleItems: (items: number[]) => void
) => {
  const handleApplyCredit = (amount: number) => {
    const cartTotal = calculateCartTotal();
    const shippingCost = calculateShippingCost();
    const maxApplicable = Math.max(0, cartTotal - discount + shippingCost);
    console.log('Applying credit:', amount, 'max applicable:', maxApplicable);
    
    const creditToApply = Math.min(amount, maxApplicable);
    console.log('Credit to apply after min check:', creditToApply);
    
    applyCreditStorage(creditToApply);
    
    toast({
      title: "Store credit applied",
      description: `$${creditToApply.toFixed(2)} store credit has been applied to your order.`,
      duration: 2000
    });
  };
  
  const handleResetAppliedCredit = () => {
    console.log('Resetting applied credit');
    resetAppliedCredit();
  };

  const handleResetPromoCode = () => {
    console.log('Resetting promo code');
    setPromoCodeStorage('');
    setDiscount(0);
    setPromoEligibleItems([]);
  };

  const handleSetPromoCode = (code: string) => {
    console.log('Setting promo code:', code);
    setPromoCodeStorage(code);
    if (!code || code.trim() === '') {
      setDiscount(0);
      setPromoEligibleItems([]);
    }
  };

  return {
    handleApplyCredit,
    handleResetAppliedCredit,
    handleResetPromoCode,
    handleSetPromoCode
  };
};
